/**
 * Copyright 2017-present Palantir Technologies, Inc. All rights reserved.
 * Licensed under the MIT License (the "License"); you may obtain a copy of the
 * license at https://github.com/palantir/typesettable/blob/develop/LICENSE
 */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./writer"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/typesettable/build/src/writers/index.js
// module id = 118
// module chunks = 0